import isTimeStringValid from '../is-time-string-valid';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (timeString: string): boolean =>
	timeString.trim() === '' || isTimeStringValid(timeString);
